import {REDUCER_NAME as PARENT_REDUCER_NAME} from '../const';
import {REDUCER_NAME} from './const';

const NS = PARENT_REDUCER_NAME + '/' + REDUCER_NAME + '/';

export const SAVE_PARTNER_REQUEST = NS + 'SAVE_PARTNER_REQUEST';

export const SAVE_PARTNER_SUCCESS = NS + 'SAVE_PARTNER_SUCCESS';

export const SAVE_PARTNER_ERROR = NS + 'SAVE_PARTNER_ERROR';

export const EDIT_PARTNER = NS + 'EDIT_PARTNER';

export const VALIDATION_LIST = NS + 'VALIDATION_LIST';

export const CLEAR_STATE = NS + 'CLEAR_STATE';

export const FIND_PARTNER_REQUEST = NS + 'FIND_PARTNER_REQUEST';

export const FIND_PARTNER_SUCCESS = NS + 'FIND_PARTNER_SUCCESS';

export const FIND_PARTNER_ERROR = NS + 'FIND_PARTNER_ERROR';


// WEBPACK FOOTER //
// ./src/modules/partner/state/detail/type.js